/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { userSessionClientsGet } from "../funcs/userSessionClientsGet.js";
import { userSessionClientsList } from "../funcs/userSessionClientsList.js";
import { userSessionClientsRefreshCIMD } from "../funcs/userSessionClientsRefreshCIMD.js";
import { userSessionClientsRevoke } from "../funcs/userSessionClientsRevoke.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { UserSessionClient } from "../models/components/usersessionclient.js";
import {
  GetUserSessionClientRequest,
  GetUserSessionClientSecurity,
} from "../models/operations/getusersessionclient.js";
import {
  ListUserSessionClientsRequest,
  ListUserSessionClientsResponse,
  ListUserSessionClientsSecurity,
} from "../models/operations/listusersessionclients.js";
import {
  RefreshUserSessionClientCIMDRequest,
  RefreshUserSessionClientCIMDSecurity,
} from "../models/operations/refreshusersessionclientcimd.js";
import {
  RevokeUserSessionClientRequest,
  RevokeUserSessionClientSecurity,
} from "../models/operations/revokeusersessionclient.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class UserSessionClients extends ClientSDK {
  /**
   * getUserSessionClient userSessionClients
   *
   * @remarks
   * Get a user_session_client by id.
   */
  async get(
    request: GetUserSessionClientRequest,
    security?: GetUserSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionClient> {
    return unwrapAsync(userSessionClientsGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listUserSessionClients userSessionClients
   *
   * @remarks
   * List user_session_clients in the caller's project.
   */
  async list(
    request?: ListUserSessionClientsRequest | undefined,
    security?: ListUserSessionClientsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListUserSessionClientsResponse, { cursor: string }>> {
    return unwrapResultIterator(userSessionClientsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * refreshUserSessionClientCIMD userSessionClients
   *
   * @remarks
   * Force a CIMD client's metadata document to be re-read. Purges the stored cache state (expiry + ETag) before re-fetching, so the read is unconditional: a host answering 304 Not Modified cannot re-confirm the copy the operator is discarding. Rejected for DCR clients. Deliberately bypasses the document cache, so it carries a per-client cooldown: a refresh shortly after the last successful read returns rate_limit_exceeded.
   */
  async refreshCIMD(
    request: RefreshUserSessionClientCIMDRequest,
    security?: RefreshUserSessionClientCIMDSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionClient> {
    return unwrapAsync(userSessionClientsRefreshCIMD(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revokeUserSessionClient userSessionClients
   *
   * @remarks
   * Soft-delete a user_session_client and cascade to the user_sessions it issued. A DCR client stays revoked. A CIMD client does not: its identity is the metadata document URL, so the next /authorize re-resolves that document and registers a fresh row. Durably blocking a CIMD client is admission control's job, not revocation's.
   */
  async revoke(
    request: RevokeUserSessionClientRequest,
    security?: RevokeUserSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(userSessionClientsRevoke(
      this,
      request,
      security,
      options,
    ));
  }
}
